import type { models } from 'cesg-shared';
import { appHttpService } from '../standard/http-service';

/**
 * The one exception to "all file CRUD is client-direct to Graph": deciding "which provisioned
 * SharePoint sites belong to projects this user can see" needs our own DB (the provisioning ledger,
 * scoped to the caller's permission-visible projects), which the client shouldn't replicate.
 *
 * No delegated Graph token is involved: the server answers this from the ledger alone, so this is an
 * ordinary authenticated backend call rather than the token pass-through it used to be. Each site
 * carries its libraries' `driveId`s, and those are what the file manager then addresses Graph with
 * directly, using the user's own delegated token.
 */
class SharePointSitesService {
  async getProjectSites(): Promise<models.SharePointSite[]> {
    return appHttpService.request
      .url('/sharepoint-sites')
      .get()
      .json<models.SharePointSite[]>();
  }
}

export const sharePointSitesService = new SharePointSitesService();
